import { CONTACT_SERVICES, serviceHref } from "@/data/contact"

export function serviceGroup(service: unknown) {
  switch (service) {
    case "yoshinani-brick":
      return "lego"
    case "line-mini-app":
      return "line"
    case "ai":
    case "line-chatbot":
    case "ax-consulting":
    case "yoshinani-shindan":
      return "ai"
    case "3d-print":
      return "3d-print"
    default:
      return "all"
  }
}

/** 事業ページ配下のみ分類。ギャラリー全体をLEGOの閲覧とみなさない。 */
export function pageService(path: string) {
  const pathname = path.split(/[?#]/)[0]
  if (pathname === "/business/ai" || pathname === "/business/ai/") return "ai"
  return CONTACT_SERVICES.find(
    ({ id }) =>
      pathname === serviceHref(id) ||
      pathname?.startsWith(`${serviceHref(id)}/`),
  )?.id
}
